
import { get, post, put, del } from '../request'
/**发票管理模块 */
export default {
    /**
    * @description 查询所有发票列表
    * @param {String|Number} params 
    * @returns Object
    */
    getAllInvoiceList(params) {
        return post("/invoicing/getInvoiceList", params, true)
    },

    /**
      * @description 查询发票详情
      * @param {String|Number} params 
      * @returns Object
      */
    invoiceDetail(params) {
        return get(`/invoiceOrders/getInvoiceOrdersDetails/${params}`, {}, true)
    },
    /**
     * @description 发票作废
     * @param {String|Number} params 
     * @returns Object
     */
    invoiceCancel(params) {
        return post(`/invoicing/issueRedInvoice?invoiceId=${params}`)
    },

    /*** 开蓝票 */
    openInvoiceBlue(params){
        return post(`/invoicing/getInvoiceBlue`,params)
    },

     /*** 一键开多张蓝票 */
     openMultileInvoiceBlue(params){
        return post(`/invoicing/mergeGetInvoiceBlue`,params)
    },

    /** 发票重新推送 给用户 邮箱 */
    inviocePushToUser(params) {
        return post(`/invoiceOrders/deliveryInvoice`, params)
    },

    /** 车队卡 加油卡 充值订单开票 */
    plateCardOpenInvoice(params) {
        return post(`/invoicing/getInvoiceBlue`, params)
    },

    /** 充值记录的开票 记录列表 */
    rechangeInvoiceRecordsList(params) {
        return post(`/invoicing/getInvoiceListByOrderNo`, params)
    },
    /*** 开票设置详情 */
    openInvoiceSettingDetail(params) {
        return get(`/InvoiceConfig/getInvoiceConfig/${params}`)
    },
    /*** 开票设置添加 */
    openInvoiceSettingAddOrUpdate(params) {

        return post(`/InvoiceConfig/operateInvoiceConfig`, params)
    },
    /*** 开票设置列表 */
    openInvoiceSettingList(params) {
        return post(`/InvoiceConfig/getInvoiceConfigList`, params)
    },
    /** 获取会员用户的开票记录 */
    wxUserOpenInvoiceList(params) {
        return post(`/invoiceOrders/getInvoiceOrdersByUserId`, params)
    },

    // ===== 开票自动白名单 =====
    whitelistPage(params) {
        return get(`/invoice/whitelist/page`, params, true)
    },
    whitelistList(params) {
        return get(`/invoice/whitelist/list`, params, true)
    },
    whitelistAdd(params) {
        return post(`/invoice/whitelist/add`, params)
    },
    whitelistUpdate(params) {
        return put(`/invoice/whitelist/update`, params)
    },
    whitelistDetail(id) {
        return get(`/invoice/whitelist/${id}`, {}, true)
    },
    whitelistDelete(id) {
        return del(`/invoice/whitelist/${id}`)
    },
    whitelistBatchDelete(ids) {
        return del(`/invoice/whitelist/batch`, ids)
    },
    whitelistEnable(id) {
        return put(`/invoice/whitelist/enable/${id}`)
    },
    whitelistDisable(id) {
        return put(`/invoice/whitelist/disable/${id}`)
    },
    whitelistToggle(id) {
        return put(`/invoice/whitelist/toggle/${id}`)
    },
    whitelistBatchEnable(ids) {
        return put(`/invoice/whitelist/batch/enable`, ids)
    },
    whitelistBatchDisable(ids) {
        return put(`/invoice/whitelist/batch/disable`, ids)
    },
    whitelistCheck(params) {
        return get(`/invoice/whitelist/check`, params, true)
    },
}